import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ModalContent, ModalFooter, ModalHeader, RegularButton } from 'fronton-react';
import { checkScreenType } from 'utils';
import { BrushIcon, FilterColumn } from 'common/components';
import { selectWindowType, WindowTypes } from 'store/pageStore';
import { useFilterModal } from './hooks';

import {
	FilterBtnWrapper,
	FilterListStyle,
	FilterListWrapper,
	FilterModalWrapper,
	HeaderStyles,
	ResetButtonStyles,
} from './styles';

export const FilterModal = () => {
	const currentWindowType = useSelector(selectWindowType);
	const isMobile = checkScreenType(currentWindowType, WindowTypes.mobile);

	const {
		selectedFilterModalItems,
		topCategories,
		assignBtnHandler,
		resetBtnHandler,
		checkboxHandler,
		isModalBtnsVisible,
	} = useFilterModal();

	const firstColumnCategoriesCount = useMemo(
		() =>
			topCategories.length <= 10
				? topCategories.length
				: Math.round(topCategories.length / 2),
		[topCategories]
	);

	return (
		<>
			<ModalHeader title="Список услуг" label="" className={HeaderStyles} />
			<ModalContent style={{ padding: 0 }}>
				<FilterModalWrapper>
					<FilterListWrapper>
						<FilterColumn
							topCategories={topCategories}
							selectedFilterItems={selectedFilterModalItems}
							start={0}
							end={firstColumnCategoriesCount}
							checkboxHandler={checkboxHandler}
							className={FilterListStyle}
							dataQa="modal-filter-column--left"
						/>
						{firstColumnCategoriesCount < topCategories.length && (
							<FilterColumn
								topCategories={topCategories}
								selectedFilterItems={selectedFilterModalItems}
								start={firstColumnCategoriesCount}
								end={topCategories.length}
								checkboxHandler={checkboxHandler}
								className={FilterListStyle}
								dataQa="modal-filter-column--right"
							/>
						)}
					</FilterListWrapper>
				</FilterModalWrapper>
			</ModalContent>
			{isModalBtnsVisible && (
				<ModalFooter className={FilterBtnWrapper}>
					<RegularButton
						size="l"
						variant="primary"
						onClick={assignBtnHandler}
						data-qa="assign-btn"
					>
						Применить
					</RegularButton>
					<RegularButton
						size="l"
						variant="secondary"
						className={ResetButtonStyles}
						onClick={resetBtnHandler}
						data-qa="reset-btn"
					>
						<BrushIcon />
						{isMobile ? '' : 'Сбросить'}
					</RegularButton>
				</ModalFooter>
			)}
		</>
	);
};
